<app-window
  [visible]="isVisible"
  title="{{'importMangas' | transloco}}"
  [width]="'500px'"
  [height]="'400px'"
  position="center"
  [showClose]="true"
  [closeDisabled]="filesProcessing"
  [showHide]="false"
  (close)="onWindowClose()">
  <div class="molv-container">
    <input type="text" class="molv-txtbx" placeholder="{{'mangaName' | transloco}}" [(ngModel)]="localFileName" [disabled]="filesProcessing" />
    <button class="molv-btn molv-btn-pink" (click)="saveAndClose()" [disabled]="filesProcessing || !localFileName">{{'save' | transloco}}</button>
    <molv-drop-uploader [visible]="isVisible" [tabId]="tabId" [saveAll$]="saveAll$" [clearAll$]="clearAll$"
      (onDropFinished)="onUploadFinished()" (filesProcessing)="filesProcessing = $event" (fileSelected)="onFileSelected($event)"></molv-drop-uploader>
  </div>
</app-window>
